var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { execute, makePromise } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import axios from 'axios';
var axiosFetch = function (uri, options) { return __awaiter(void 0, void 0, void 0, function () {
    var requests, baseUri, operationName, operationPath, resp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requests = JSON.parse(options.body);
                baseUri = uri.endsWith('/') ? uri : uri + "/";
                operationName = encodeURIComponent(requests[0].operationName || 'anonymous');
                operationPath = requests.length > 1 ? operationName + "/batch/" + requests.length : operationName + ".json";
                return [4 /*yield*/, axios.request({
                        url: baseUri + operationPath,
                        method: options.method,
                        headers: options.headers,
                        data: options.body,
                        withCredentials: true,
                    })];
            case 1:
                resp = _a.sent();
                return [2 /*return*/, new Response(JSON.stringify(resp.data), {
                        status: resp.status,
                        statusText: resp.statusText,
                        headers: new Headers(resp.headers),
                    })];
        }
    });
}); };
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(_a) {
        var _this = this;
        var endpointUrl = _a.endpointUrl;
        this.query = function (query, variables) {
            if (variables === void 0) { variables = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var result, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, makePromise(execute(this.httpLink, {
                                    query: query,
                                    variables: variables,
                                }))];
                        case 1:
                            result = _a.sent();
                            if (result.errors) {
                                throw new GraphQLOperationFailed({ type: result.errors[0].type, query: query, variables: variables });
                            }
                            return [2 /*return*/, result.data];
                        case 2:
                            err_1 = _a.sent();
                            if (/Response not successful: Received status code [0-9]{3}/.test(err_1.message)) {
                                throw new GraphQLHttpError({ query: query, variables: variables, response: err_1.response });
                            }
                            throw err_1;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        this.httpLink = new BatchHttpLink({ uri: endpointUrl, fetch: axiosFetch, batchKey: function (op) { return op.operationName; } });
    }
    return GraphQLClient;
}());
var GraphQLQueryException = /** @class */ (function (_super) {
    __extends(GraphQLQueryException, _super);
    function GraphQLQueryException(_a) {
        var message = _a.message, query = _a.query, variables = _a.variables;
        var _this = _super.call(this) || this;
        _this.name = 'GraphQLQueryException';
        _this.message = message;
        _this.query = query;
        _this.variables = variables;
        return _this;
    }
    return GraphQLQueryException;
}(Error));
export { GraphQLQueryException };
var GraphQLHttpError = /** @class */ (function (_super) {
    __extends(GraphQLHttpError, _super);
    function GraphQLHttpError(_a) {
        var query = _a.query, variables = _a.variables, response = _a.response;
        var _this = _super.call(this, {
            message: "A GraphQL operation is failed because the HTTP response has an exceptional status code. (" + response.status + " " + response.statusText + ")",
            query: query,
            variables: variables,
        }) || this;
        _this.name = 'GraphQLHttpError';
        _this.response = response;
        return _this;
    }
    return GraphQLHttpError;
}(GraphQLQueryException));
export { GraphQLHttpError };
var GraphQLOperationFailed = /** @class */ (function (_super) {
    __extends(GraphQLOperationFailed, _super);
    function GraphQLOperationFailed(_a) {
        var type = _a.type, query = _a.query, variables = _a.variables;
        var _this = _super.call(this, {
            message: "A GraphQL operation is failed because the request is incorrect. (type: " + type + ")",
            query: query,
            variables: variables,
        }) || this;
        _this.name = 'GraphQLOperationFailed';
        _this.type = type;
        return _this;
    }
    return GraphQLOperationFailed;
}(GraphQLQueryException));
export { GraphQLOperationFailed };
export default GraphQLClient;
